import { Button } from "@blueprintjs/core";
import { ButtonContainer, FGCheckboxInput, FGCustomInput, FGCustomPanel } from "nsitools-react";
import * as React from "react";

import { ClubJudgeApi, JudgeGridDto, SaveClubJudgeDto } from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { useApiService, useSaveApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IClubJudgeSavePanelProps {
  onSaved: () => void;
  judge: JudgeGridDto;
  clubId: number;
}

export const ClubJudgeSavePanel: React.FunctionComponent<IClubJudgeSavePanelProps> = ({ onSaved, judge, clubId }) => {
  const { t } = useTl();
  const api = useApiService(ClubJudgeApi);

  const { saving, saveItem } = useSaveApi<SaveClubJudgeDto>(
    React.useMemo(
      () => ({
        saveApiFn: (data) => api.saveNewJudge(data),
        onSaveFn: () => onSaved(),
      }),
      [api, onSaved]
    )
  );
  const initialData = React.useMemo(
    () =>
      new SaveClubJudgeDto({
        clubId: clubId,
        judgeId: judge.judgeId,
      }),
    [clubId, judge.judgeId]
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={initialData}
      editMode={true}
      saving={saving}
      hideButtons={true}
    >
      <FGCustomInput name="isAptForBeauty" label={t(ETLCodes.Judge)}>
        {(ctx) => <>{judge.name}</>}
      </FGCustomInput>
      <FGCheckboxInput name="isAptForBeauty" label={t(ETLCodes.IsAptForBeauty)} />
      <FGCheckboxInput name="isAptForWork" label={t(ETLCodes.IsAptForWork)} />
      <FGCustomPanel>
        {(ctx) => (
          <ButtonContainer>
            <Button text={t(ETLCodes.General_Save)} minimal={false} intent="primary" type="submit" />
          </ButtonContainer>
        )}
      </FGCustomPanel>
    </SmallFormGenerator>
  );
};
